import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {categoryToIcon, categoryToLabel, MilestoneCategory} from '../../../../model/milestones/MilestoneCategory';

@Component({
  selector: 'digires-milestone-category-icon',
  templateUrl: './milestone-category-icon.component.html',
  styleUrls: ['./milestone-category-icon.component.scss']
})
export class MilestoneCategoryIconComponent implements OnChanges {

  @Input() category: MilestoneCategory;
  label: string;
  icon: string;

  ngOnChanges() {
    this.label = categoryToLabel[this.category];
    this.icon = categoryToIcon[this.category];
  }

}
